import React, { useEffect, useRef } from 'react';
import { Content, Header, SafeAreaView } from './ContentSafeAreaView.styles';
import { ReactComponent as LogoIcon } from '../../../assets/icons/logo.svg';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { selectScrollPosition, setScrollPosition } from '../../../store/slices/influencer/slice';
import { FEED } from '../../App/routes';
import { getSafeAreaInset } from '../../../utils/telegram';

const ContentSafeAreaView = ({ children, removeTop, removeBottom, hideLogo, hideScrollbar }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { top, bottom } = getSafeAreaInset();
  const scrollPosition = useSelector(selectScrollPosition);
  const scrollContentRef = useRef();

  const onScroll = e => {
    const target = e.currentTarget;
    if (location.pathname.includes(FEED)) {
      dispatch(setScrollPosition(target?.scrollTop || 0));
    }
  };

  useEffect(() => {
    if (location.pathname.includes(FEED)) {
      scrollContentRef.current.scrollTo({ top: scrollPosition });
    }
    // eslint-disable-next-line
  }, [location.pathname]);

  return (
    <SafeAreaView $top={removeTop ? 0 : top} $bottom={removeBottom ? 0 : bottom}>
      {!hideLogo && (
        <Header>
          <LogoIcon />
        </Header>
      )}
      <Content $hideLogo={hideLogo} $hideScrollbar={hideScrollbar} onScroll={onScroll} ref={scrollContentRef}>
        {children}
      </Content>
    </SafeAreaView>
  );
};

export default ContentSafeAreaView;
